import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
  ListSubheader,
} from "@mui/material";
import {
  Control,
  Controller,
  FieldErrors,
  FieldError,
  FieldValues,
  Path,
} from "react-hook-form";
import { DropdownOptionGroup } from "../types/DropdownOption.ts";

type LabsDropdownProps<T extends FieldValues> = {
  control: Control<T>;
  onChange: (e: SelectChangeEvent) => void;
  errors: FieldErrors;
  optionsByGroup: DropdownOptionGroup[];
  label: string;
  name: Path<T>;
};

export const LabsDropdown = <T extends FieldValues>({
  control,
  onChange,
  errors,
  optionsByGroup,
  label,
  name,
}: LabsDropdownProps<T>) => (
  <Box>
    <FormControl sx={{ width: "100%", mb: 2 }} error={!!errors[name]}>
      <InputLabel id={`${name}-label`}>{label}</InputLabel>
      <Controller
        name={name}
        control={control}
        rules={{ required: `${label} is required` }}
        render={({ field }) => (
          <Select
            {...field}
            labelId={`${name}-label`}
            id={name}
            label={label}
            value={field.value || ""}
            onChange={(e) => {
              field.onChange(e);
              onChange(e);
            }}
            variant={"outlined"}
            required
          >
            {optionsByGroup.map((group) => [
              <ListSubheader key={group.label}>{group.label}</ListSubheader>,
              ...group.options.map((option) => (
                <MenuItem
                  key={`${group.label}_${option.label}`}
                  value={option.value}
                >
                  {option.label}
                </MenuItem>
              )),
            ])}
          </Select>
        )}
      />
      {errors[name] && (
        <Typography variant="body2" color="error">
          {/* not sure why we need to cast... seems like react-hook-form types are wrong */}
          {(errors[name] as FieldError).message}
        </Typography>
      )}
    </FormControl>
  </Box>
);
